import React, { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  CardHeader,
  DropdownItem,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  Modal,
  ModalBody,
} from "reactstrap";
import { Btn, H4 } from "../../../../../AbstractElements";
import BookingModal from "./TreatmentBookingModal";
import DataTable from "react-data-table-component";
import { AppointmentList, AppointmentStatus } from "../../../../../apiController";
import { toast } from "react-toastify";

const DropdownCell = ({ items }) => (
  <UncontrolledDropdown className="me-2" direction="down">
    <DropdownToggle caret color="secondary">
      Open
    </DropdownToggle>
    <DropdownMenu>
      {items.items.map((itm) => (
        <DropdownItem key={itm.id}>{itm.name}</DropdownItem>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

const Scheduled = ({permission}) => {

  const treatmentPlanPermission = permission.module_name === "PD Summary"
  console.error(treatmentPlanPermission)
  // const [data, setData] = useState([]);
  const [appointmentList, setAppoinmentList] = useState([]);
  const [editData, setEditData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const item = {
    btnText: "Open",
    items: ["Open", "Inprogress", "Completed", "Cancel"],
  };

  const { data } = location.state || {};
  const [currentDateFormat, setCurrentDateFormat] = useState('');


  useEffect(() => {
    // let isMounted = true;
    // if (isMounted) {
    //   axios.get(UserEditTableAPI).then((res) => setData(res.data));
    // }
    // return () => {
    //   isMounted = false;
    // };
    fetchAppointmentList();
  }, []);

  const handleStatusChange = (selectedValue, row) => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setCurrentDateFormat(formattedDate);

    console.error(row)
  
    const status = {
      appointment_status: selectedValue,
      id: String(row.id),
      inprogress_date: row.inprogress_date ? row.inprogress_date : formattedDate,
      complete_date: selectedValue === "Completed" ? formattedDate : "",
    };
  
    console.warn(status);
    appointmentStatus(status)
  };

  //AppointmentStatus
 const appointmentStatus = async (status) => {
  try{
    const response = await AppointmentStatus(status);
      if (response.status === true) {
        toast.success("Status Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {

      fetchAppointmentList()
      // toggle()
      // setLarge(!Large);
    }
  
 }
  
  const appointmentListData = appointmentList.flatMap((row, ind) => {
    const patientTreatment = JSON.parse(row.patient_treatment);
    const createdDate = new Date(row.appointment_date);
    const formattedDate = createdDate.toISOString().split("T")[0];
  
    const statusLabels = {
      Next: "Appointment Completed",
      Rescheduled: "Rescheduled",
      Completed: "Completed",
      Cancel: "Cancelled",
      default: row.is_booked ? "Booked" : (
        <span>
          <Btn
            attrBtn={{
              className: "focuse-none",
              color: "secondary",
              size: "sm",
              onClick: () => toggleModal(row),
            }}
          >
            {row.appointment_status === "Inprogress" ? "Next" : "Reschedule"}
          </Btn>
        </span>
      )
    };
    const status = row.appointment_status;
    const statusLabel = statusLabels[status] || statusLabels.default;
  
    return {
      ind: ind + 1,
      id: row.id,
      date: formattedDate,
      type: patientTreatment.type === "tooth" ? (
        <p>{patientTreatment.tooth}</p>
      ) : (
        patientTreatment.type
      ),
      diagnosis: patientTreatment.problem ? patientTreatment.problem.name : "-",
      treatmentmethod: patientTreatment.itemsPr
        ? patientTreatment.itemsPr.map((t) => t.mname).join(", ")
        : "-",
      price: patientTreatment.itemsPr
        ? patientTreatment.itemsPr.map((t) => t.price).join(", ")
        : "-",
      doctor: row.doctor_first_name,
      book: statusLabel,
      // book: statusLabels[row.appointment_status] || statusLabels.default,
      status: 
      ["Completed", "Cancel", "Rescheduled", "Next"].includes(status) ? (
        <span>{statusLabel}</span>
      ) :(
        
        <UncontrolledDropdown className="me-2" direction="down">
        <DropdownToggle caret color="secondary">
          {row.appointment_status? row.appointment_status :'Open'}
        </DropdownToggle>
        <DropdownMenu>
          {item.items.map((itm) => (
            <DropdownItem key={itm}
              onClick={() => handleStatusChange(itm, row)}>{itm}</DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
      ),
    };
  });
  

  {
    /* <DropdownCell items={item} /> */
  }
  const fetchAppointmentList = async () => {
    const response = await AppointmentList();
    if (response.status === true) {
      const filteredList = await response.data.filter(
        (list) => list.patient_id === data.id
      ).reverse();
      // console.log(response.data)
      // console.log(filteredList)
      setAppoinmentList(filteredList);
    }
  };

  const tableColumns = [
    {
      name: "#",
      selector: (row) => row["ind"],
      sortable: true,
      center: false,
    },
    {
      name: "Date",
      selector: (row) => row["date"],
      sortable: true,
      center: false,
    },
    {
      name: "Type/ Tooth no",
      selector: (row) => row["type"],
      sortable: true,
      center: true,
    },
    {
      name: "Diagnosis",
      selector: (row) => `${row.diagnosis}`,
      sortable: true,
      center: true,
    },
    {
      name: "Treatment Method",
      selector: (row) => `${row.treatmentmethod}`,
      sortable: true,
      center: true,
    },
    {
      name: "Treament Price",
      selector: (row) => row["price"],
      sortable: false,
      center: true,
    },
    {
      name: "Doctor",
      selector: (row) => row["doctor"],
      sortable: false,
      center: true,
    },
    // {
    //   name: "Scheduled",
    //   selector: (row) => row["book"],
    //   sortable: false,
    //   center: true,
    // },
    // {
    //   name: "Status",
    //   selector: (row) => row["status"],
    //   sortable: false,
    //   center: true,
    // },
  ];

  if (permission?.create_access) {
    tableColumns.push({
      name: "Scheduled",
      selector: (row) => row["book"],
      sortable: false,
      center: true,
    });
  }
  
  // Conditionally add the "Edit" column if edit_access is true
  if (permission?.edit_access) {
    tableColumns.push({
      name: "Status",
      selector: (row) => row["status"],
      sortable: false,
      center: true,
    });
  }

  const toggleModal = (editData) => {
    setEditData(editData);

    setIsModalOpen(!isModalOpen);
  };

  return (
    <Fragment>
      <Card>
        <CardHeader>
          <H4 attrH4={{ className: "card-title mb-0" }}>{"Scheduled"}</H4>
        </CardHeader>
        {/* <DataTable
          data={appointmentListData}
          columns={tableColumns}
          striped={true}
          center={true}
          pagination
          fixedHeader
          title='Appoitment List'
          // selectableRows
          // onSelectedRowsChange={handleRowSelected}
          // clearSelectedRows={toggleDelet}
        /> */}
        <div className='table-responsive edit-table'>
          <table className='table card-table table-vcenter text-nowrap'>
            <thead>
              <tr>
                {tableColumns.map((items, i) => (
                  <th key={i}>{items.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {appointmentListData.map((items, i) => (
        <tr key={i}>
          <td>{items.ind}</td>
          <td>{items.date}</td>
          <td>{items.type}</td>
          <td>{items.diagnosis}</td>
          <td>{items.treatmentmethod}</td>
          <td>{items.price}</td>
          <td>{items.doctor}</td>
          {permission?.create_access && <td>{items.book}</td>}
          {permission?.edit_access &&  <td>{items.status}</td>}
        </tr>
      ))}
            </tbody>
          </table>
        </div>
      </Card>

      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalBody>
          <BookingModal toggle={toggleModal} edit={editData} />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default Scheduled;